<template>
  <div>
    <b-button
      v-if="signedIn"
      variant="outline-primary"
      class="mb-0 mb-sm-4 mb-lg-0"
      block
      pill
      right
      @click="signOut"
      aria-label="Sign out"
    >
      Sign Out
    </b-button>
    <b-button
      v-else
      @click="openModal()"
      :class="signedIn ? 'mb-0 mb-sm-4 mb-lg-0' : 'mb-0 mb-lg-0'"
      variant="outline-primary"
      block
      pill
      right
      aria-label="Sign in"
    >
      Sign In
    </b-button>
    <b-modal
      ref="sign-in"
      v-model="showModal"
      size="md"
      centered
      body-class="d-flex fixed-height align-items-center pb-5 pt-0 px-3 px-lg-5"
      content-class="px-3"
      title-tag="span"
      :hide-header-close="signInRequired"
      :no-close-on-backdrop="signInRequired"
      hide-footer
      @hidden="onHidden"
    >
      <template v-slot:modal-title>
        <b-link v-if="showResetPassword" class="text-secondary" @click="toggleResetPassword">
          &lt; Back to Sign In
        </b-link>
      </template>
      <transition name="fade" mode="out-in">
        <SignInForm
          v-if="!showResetPassword"
          @toggleResetPassword="toggleResetPassword"
          @closeModal="closeModal"
          @submitSuccess="closeModal"
        />
        <ResetPasswordForm v-else @toggleResetPassword="toggleResetPassword" />
      </transition>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import SignInForm from '@/components/account/SignInForm.vue';
import ResetPasswordForm from '@/components/account/ResetPasswordForm.vue';

export default {
  name: 'SignInModal',
  components: {
    SignInForm,
    ResetPasswordForm,
  },
  data() {
    return {
      showModal: false,
      showResetPassword: false,
    };
  },
  created() {
    this.$router.onReady(this.handleQuery);
  },
  computed: {
    ...mapState('User', {
      signedIn: state => state.signedIn,
      signInRequired: state => state.signInRequired,
    }),
  },
  watch: {
    signInRequired(newValue) {
      if (newValue) this.openModal();
    },
  },
  methods: {
    openModal() {
      this.$emit('modalOpened');
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    onHidden() {
      this.showResetPassword = false;
    },
    handleQuery() {
      if (this.$route.query.accountActivated) {
        this.openModal();
      }
      if (this.$route.query.returnUrl && !this.signedIn) {
        this.openModal();
      }
    },
    toggleResetPassword() {
      this.showResetPassword = !this.showResetPassword;
    },
    signOut() {
      const signedOut = () => {
        // Navigates to home page and reloads the page to clear state.
        window.location.assign(window.location.origin);
      };
      axios.post('/api/signout').then(() => {
        signedOut();
      })
        .catch((error) => {
          if (error.response && error.response.status === 401) signedOut();
        });
    },
  },
};
</script>
